var render = function render(){
  var _find, _vm$optionsCompanies$, _vm$fleetOwnershipOpt, _vm$data, _vm$data$contract_typ, _vm$data2, _vm$data2$contract_ty, _vm$data3, _vm$data3$terms, _vm$data$pol, _vm$data$pod, _vm$optionsCargoType$, _vm$optionUnit$find;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "detail-table-container mb-4"
  }, [_c('table', {
    staticClass: "table detail-table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-label pt-0"
  }, [_vm._v("Subject")]), _c('td', {
    staticClass: "detail-separator p-0"
  }, [_vm._v(":")]), _c('td', {
    staticClass: "detail-value pt-0"
  }, [_vm._v(" " + _vm._s(_vm.data.subject) + " ")])]), _c('tr', [_c('td', {
    staticClass: "detail-label pt-0"
  }, [_vm._v("Priority")]), _c('td', {
    staticClass: "detail-separator p-0"
  }, [_vm._v(":")]), _c('td', {
    staticClass: "detail-value pt-0"
  }, [_vm._v(" " + _vm._s((_find = [{
    value: 1,
    text: 'Low'
  }, {
    value: 2,
    text: 'Medium'
  }, {
    value: 3,
    text: 'High'
  }, {
    value: 5,
    text: 'Normal (Default)'
  }].find(function (el) {
    return el.value === _vm.data.priority ? Number(_vm.data.priority) : 5;
  })) === null || _find === void 0 ? void 0 : _find.text) + " ")])]), _c('tr', [_c('td', {
    staticClass: "detail-label pt-0"
  }, [_vm._v("Company Name")]), _c('td', {
    staticClass: "detail-separator p-0"
  }, [_vm._v(":")]), _c('td', {
    staticClass: "detail-value pt-0"
  }, [_vm._v(" " + _vm._s(((_vm$optionsCompanies$ = _vm.optionsCompanies.find(function (el) {
    return el.value === _vm.data.company_id;
  })) === null || _vm$optionsCompanies$ === void 0 ? void 0 : _vm$optionsCompanies$.text) || '-') + " ")])]), _c('tr', [_c('td', {
    staticClass: "detail-label"
  }, [_vm._v("Fleet Ownership")]), _c('td', {
    staticClass: "detail-separator"
  }, [_vm._v(":")]), _c('td', {
    staticClass: "detail-value"
  }, [_vm._v(" " + _vm._s(((_vm$fleetOwnershipOpt = _vm.fleetOwnershipOptions.find(function (el) {
    return el.value === _vm.data.fleet_ownership;
  })) === null || _vm$fleetOwnershipOpt === void 0 ? void 0 : _vm$fleetOwnershipOpt.text) || '-') + " ")])]), _c('tr', [_c('td', {
    staticClass: "detail-label"
  }, [_vm._v("Company Third Party")]), _c('td', {
    staticClass: "detail-separator"
  }, [_vm._v(":")]), _c('td', {
    staticClass: "detail-value"
  }, [_vm._v(" " + _vm._s(_vm.data.third_party_company || '-') + " ")])]), _c('tr', [_c('td', {
    staticClass: "detail-label"
  }, [_vm._v("Fleet Type")]), _c('td', {
    staticClass: "detail-separator"
  }, [_vm._v(":")]), _c('td', {
    staticClass: "detail-value"
  }, [_c('div', {
    staticClass: "fleet-types-container"
  }, [_vm.selectedFleetTypes && _vm.selectedFleetTypes.length > 0 ? _vm._l(_vm.selectedFleetTypes, function (fleet, index) {
    return _c('b-badge', {
      key: index,
      staticClass: "fleet-type-badge",
      attrs: {
        "variant": "light"
      }
    }, [_vm._v(" " + _vm._s((fleet === null || fleet === void 0 ? void 0 : fleet.text) || (fleet === null || fleet === void 0 ? void 0 : fleet.name) || '-') + " ")]);
  }) : [_vm._v("-")]], 2)])]), _c('tr', [_c('td', {
    staticClass: "detail-label"
  }, [_vm._v("Period")]), _c('td', {
    staticClass: "detail-separator"
  }, [_vm._v(":")]), _c('td', {
    staticClass: "detail-value"
  }, [_vm._v(" " + _vm._s(_vm.formatDateRange(_vm.data.periode_start, _vm.data.periode_end)) + " ")])]), _c('tr', [_c('td', {
    staticClass: "detail-label"
  }, [_vm._v("Shipment Plan Number")]), _c('td', {
    staticClass: "detail-separator"
  }, [_vm._v(":")]), _c('td', {
    staticClass: "detail-value"
  }, [_vm._v(_vm._s(_vm.data.shipment_plan_number || '-'))])]), _c('tr', [_c('td', {
    staticClass: "detail-label"
  }, [_vm._v("Contract Type")]), _c('td', {
    staticClass: "detail-separator"
  }, [_vm._v(":")]), _c('td', {
    staticClass: "detail-value"
  }, [_vm._v(" " + _vm._s(((_vm$data = _vm.data) === null || _vm$data === void 0 ? void 0 : (_vm$data$contract_typ = _vm$data.contract_type) === null || _vm$data$contract_typ === void 0 ? void 0 : _vm$data$contract_typ.name) || '-') + " "), ((_vm$data2 = _vm.data) === null || _vm$data2 === void 0 ? void 0 : (_vm$data2$contract_ty = _vm$data2.contract_type) === null || _vm$data2$contract_ty === void 0 ? void 0 : _vm$data2$contract_ty.is_spal) === 1 ? [_c('b-badge', {
    staticClass: "ml-2",
    attrs: {
      "variant": "info"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" This type using "), _c('strong', [_vm._v("SPAL")])])] : _vm._e()], 2)]), _c('tr', [_c('td', {
    staticClass: "detail-label"
  }, [_vm._v("Term")]), _c('td', {
    staticClass: "detail-separator"
  }, [_vm._v(":")]), _c('td', {
    staticClass: "detail-value"
  }, [_vm._v(" " + _vm._s(((_vm$data3 = _vm.data) === null || _vm$data3 === void 0 ? void 0 : (_vm$data3$terms = _vm$data3.terms) === null || _vm$data3$terms === void 0 ? void 0 : _vm$data3$terms.name) || '-') + " ")])]), _c('tr', [_c('td', {
    staticClass: "detail-label"
  }, [_vm._v("Port of Loading")]), _c('td', {
    staticClass: "detail-separator"
  }, [_vm._v(":")]), _c('td', {
    staticClass: "detail-value"
  }, [_vm._v(" " + _vm._s((_vm$data$pol = _vm.data.pol) !== null && _vm$data$pol !== void 0 && _vm$data$pol.length ? _vm.data.pol[0].value : '-') + " ")])]), _c('tr', [_c('td', {
    staticClass: "detail-label"
  }, [_vm._v("Port of Discharging")]), _c('td', {
    staticClass: "detail-separator"
  }, [_vm._v(":")]), _c('td', {
    staticClass: "detail-value"
  }, [_vm._v(" " + _vm._s((_vm$data$pod = _vm.data.pod) !== null && _vm$data$pod !== void 0 && _vm$data$pod.length ? _vm.data.pod[0].value : '-') + " ")])]), _c('tr', [_c('td', {
    staticClass: "detail-label"
  }, [_vm._v("Distance")]), _c('td', {
    staticClass: "detail-separator"
  }, [_vm._v(":")]), _c('td', {
    staticClass: "detail-value"
  }, [_vm._v(" " + _vm._s(_vm.data.distance ? "".concat(_vm.data.distance, " NM") : '-') + " ")])]), _c('tr', [_c('td', {
    staticClass: "detail-label"
  }, [_vm._v("Laycan")]), _c('td', {
    staticClass: "detail-separator"
  }, [_vm._v(":")]), _c('td', {
    staticClass: "detail-value"
  }, [_vm._v(" " + _vm._s(_vm.formatDateRange(_vm.data.laycan_start, _vm.data.laycan_end)) + " ")])]), _c('tr', [_c('td', {
    staticClass: "detail-label"
  }, [_vm._v("Cargo")]), _c('td', {
    staticClass: "detail-separator"
  }, [_vm._v(":")]), _c('td', {
    staticClass: "detail-value"
  }, [_vm._v(" " + _vm._s(((_vm$optionsCargoType$ = _vm.optionsCargoType.find(function (el) {
    return el.value === _vm.data.cargo_type_id;
  })) === null || _vm$optionsCargoType$ === void 0 ? void 0 : _vm$optionsCargoType$.text) || '-') + " - " + _vm._s(_vm.formatCurrency(_vm.totalQuantity)) + " " + _vm._s(((_vm$optionUnit$find = _vm.optionUnit.find(function (el) {
    return el.value === _vm.data.unit;
  })) === null || _vm$optionUnit$find === void 0 ? void 0 : _vm$optionUnit$find.text) || '') + " ")])]), _c('tr', [_c('td', {
    staticClass: "detail-label"
  }, [_vm._v("Freight Rate")]), _c('td', {
    staticClass: "detail-separator"
  }, [_vm._v(":")]), _c('td', {
    staticClass: "detail-value"
  }, [_vm._v(" IDR " + _vm._s(_vm.formatCurrency(_vm.data.freight_rate_est)) + " "), _vm.data.include_ppn ? [_c('b-form-checkbox', {
    staticClass: "ml-2",
    attrs: {
      "disabled": "",
      "inline": ""
    },
    model: {
      value: _vm.data.include_ppn,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "include_ppn", $$v);
      },
      expression: "data.include_ppn"
    }
  }, [_vm._v(" Include PPN ")])] : _vm._e()], 2)]), _c('tr', [_c('td', {
    staticClass: "detail-label"
  }, [_vm._v("Remarks")]), _c('td', {
    staticClass: "detail-separator"
  }, [_vm._v(":")]), _c('td', {
    staticClass: "detail-value"
  }, [_vm._v(" " + _vm._s(_vm.data.remarks || 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.') + " ")])])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }